module.exports = "pegasus/assets/blocks/column-11-theme2.png";